export default {
  getQueries(state) {
    return state.queries;
  },
};
